import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    font-family: 'Montserrat';\n    align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledSwitch = styled.div(_templateObject());
export var StyledToggle = styled.label(_templateObject2(), function (props) {
  return "\n        width: 38px;\n        height: 14px;\n        border-radius: 15px;\n        background: ".concat(props.theme.components.input.disabled, ";\n\n        ").concat(props.disabled ? "\n                    cursor: auto;\n                " : "\n                    cursor: pointer;\n                ", "\n\n        input:disabled + & {\n            background: ").concat(props.theme.components.input.disabled, ";\n        }\n\n        &::after {\n            content: \"\";\n            display: block;\n            border-radius: 50%;\n            width: 18px;\n            height: 18px;\n            background: #ffffff;\n            box-shadow: 0px 1px 6px 1px rgba(0,0,0,0.2);\n            transition: ").concat(props.theme.components.input.transition, ";\n            margin-top: -2px;\n\n            input:disabled + & {\n                background: #F0F0F0;\n            }\n        }\n    ");
});
export var StyledInput = styled.input.attrs(function () {
  return {
    type: 'checkbox'
  };
})(_templateObject3(), function (props) {
  return "\n        opacity: 0;\n        z-index: 1;\n        border-radius: 15px;\n        width: 42px;\n        height: 26px;\n        display: none;\n\n        &:checked + ".concat(StyledToggle, " {\n            background: ").concat(props.disabled ? props.theme.components.input.switch.disabled : props.theme.components.input.switch.enabled, ";\n\n            &::after {\n                content: \"\";\n                display: block;\n                border-radius: 50%;\n                width: 18px;\n                height: 18px;\n                margin-left: 21px;\n                transition: ").concat(props.theme.components.input.transition, ";\n                background: ").concat(props.disabled ? props.theme.components.input.switch.disabledVariant : props.theme.components.input.switch.disabled, ";\n            }\n        }\n    ");
});
export var StyledLabel = styled.label(_templateObject4(), function (props) {
  return "\n        cursor: ".concat(props.disabled ? 'auto' : 'pointer', ";\n        margin-left: ").concat(props.theme.components.input.marginLeft, ";\n        color: ").concat(props.theme.components.input.unselected, ";\n        font-size: ").concat(props.theme.components.input.fontSize, ";\n        line-height: ").concat(props.theme.components.input.lineHeight, ";\n        font-weight: ").concat(props.theme.components.input.fontWeight, ";\n        letter-spacing: 0.5px;\n\n        ").concat(StyledInput, ":checked ~ & {\n            color: ").concat(props.theme.components.input.text, ";\n        }\n\n        ").concat(StyledInput, ":disabled ~ & {\n            color: ").concat(props.theme.components.input.disabled, ";\n        }\n    ");
});